import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { initAnalytics, captureUTM } from "@/lib/analytics";

captureUTM();
initAnalytics();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// The crawl-only SEO shell in index.html feeds non-JS crawlers real content; once the
// React app has mounted we remove it so the live DOM keeps a single H1 per route.
if (typeof requestAnimationFrame !== "undefined") {
  requestAnimationFrame(() => document.getElementById("seo-fallback")?.remove());
}
